import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  page: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  },
  iconCircle: {
    ...theme.mixins.appIconTintCircle,
    width: 88,
    height: 88,
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    color: theme.palette.primary.main,
  },
  icon: {
    width: 34,
    height: 34,
    display: 'block',
  },
  appContainer: {
    ...theme.mixins.appContainer,
    width: '100%',
    maxWidth: 560,
    padding: theme.spacing(3),
    textAlign: 'center',
    color: theme.palette.text.primary,
  },
}));
